export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref5136.02252e82.jpg";